import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import MasterContextProvider from "./MasterContext";

ReactDOM.render(
    <React.StrictMode>
        <MasterContextProvider>
            <App/>
        </MasterContextProvider>
    </React.StrictMode>,
    document.getElementById('root')
);

serviceWorker.unregister();
